import { Controller } from "@hotwired/stimulus"
import Uppy from "@uppy/core"
import Dashboard from "@uppy/dashboard"
import ActiveStorageUpload from "../vendor/uppy_activestorage_upload"

export default class extends Controller {
  static targets = ["dashboard", "fields", "submit", "status"]
  static values = {
    fieldName: { type: String, default: "file_signed_ids" },
  }

  connect() {
    this.uppy = new Uppy({
      autoProceed: true,
      allowMultipleUploads: true,
      restrictions: {},
    })

    this.uppy.use(Dashboard, {
      inline: true,
      target: this.dashboardTarget,
      proudlyDisplayPoweredByUppy: false,
      height: 320,
    })
    this.uppy.use(ActiveStorageUpload, {
      directUploadUrl: this.directUploadUrl,
    })

    this.uppy.on("complete", (result) => this.onComplete(result))
  }

  disconnect() {
    this.uppy?.destroy()
  }

  onComplete(result) {
    result.successful.forEach((file) => this.addSignedIdField(file))

    const count = result.successful.length
    if (count === 0) return

    if (this.hasStatusTarget) {
      this.statusTarget.textContent = `${count} file${count === 1 ? "" : "s"} ready to add`
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
    }
  }

  addSignedIdField(file) {
    const uppyFile = this.uppy.getFile(file.id) || file
    const signedId =
      uppyFile.response?.directUploadSignedId || uppyFile.response?.signed_id
    if (!signedId) return
    if (this.fieldsTarget.querySelector(`input[data-file-id="${file.id}"]`)) return

    const field = document.createElement("input")
    field.type = "hidden"
    field.name = `${this.fieldNameValue}[]`
    field.value = signedId
    field.dataset.fileId = file.id
    this.fieldsTarget.appendChild(field)
  }

  get directUploadUrl() {
    return document
      .querySelector("meta[name='direct-upload-url']")
      ?.getAttribute("content")
  }
}
